import * as React from "react"

// Voltar fecha o modal (pedido do Rick, 18/10/2026): no celular o gesto ou o
// botão de voltar saía da página com o modal aberto. Cada modal aberto põe uma
// entrada no histórico com a mesma URL; o voltar consome essa entrada e fecha
// só o modal de cima. Fechar pelo X, por fora ou pelo Esc devolve a entrada.
//
// Modal que tem rota própria (/deals/1/show, /contacts/create...) não usa: o
// voltar já troca a rota, e o fechar dele navega — com a entrada extra, o
// voltar viraria um laço.

type Aberto = { id: string; fechar: () => void }

const pilha: Aberto[] = []
let ignorar = 0
let ouvindo = false

const aoVoltar = () => {
  if (ignorar > 0) {
    ignorar -= 1
    return
  }
  const topo = pilha.pop()
  topo?.fechar()
}

const marcado = (id: string) =>
  (window.history.state as { __modal?: string } | null)?.__modal === id

export function useVoltarFecha(aberto: boolean, fechar: () => void, ativo = true) {
  const fecharRef = React.useRef(fechar)
  fecharRef.current = fechar

  React.useEffect(() => {
    if (!aberto || !ativo || typeof window === "undefined") return
    if (!ouvindo) {
      window.addEventListener("popstate", aoVoltar)
      ouvindo = true
    }
    const id = Math.random().toString(36).slice(2)
    const item: Aberto = { id, fechar: () => fecharRef.current() }
    window.history.pushState({ ...(window.history.state ?? {}), __modal: id }, "")
    pilha.push(item)
    return () => {
      const i = pilha.indexOf(item)
      if (i < 0) return // saiu pelo voltar: a entrada já foi consumida
      pilha.splice(i, 1)
      // Se o fechar navegou para outra rota, a entrada ficou para trás; deixa.
      if (marcado(id)) {
        ignorar += 1
        window.history.back()
      }
    }
  }, [aberto, ativo])
}

/** Estado de aberto do Root: controlado por quem usa ou interno (com Trigger). */
export function useAbertoComVoltar(
  open: boolean | undefined,
  defaultOpen: boolean | undefined,
  onOpenChange: ((open: boolean) => void) | undefined,
  ativo: boolean,
) {
  const [interno, setInterno] = React.useState(defaultOpen ?? false)
  const aberto = open ?? interno
  const mudar = React.useCallback(
    (v: boolean) => {
      if (open === undefined) setInterno(v)
      onOpenChange?.(v)
    },
    [open, onOpenChange],
  )
  useVoltarFecha(aberto, () => mudar(false), ativo)
  return [aberto, mudar] as const
}
